const RAZORPAY_SCRIPT_URL = "https://checkout.razorpay.com/v1/checkout.js";

let razorpayScriptPromise = null;

export function loadRazorpayScript() {
  if (typeof window !== "undefined" && window.Razorpay) {
    return Promise.resolve();
  }
  if (!razorpayScriptPromise) {
    razorpayScriptPromise = new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = RAZORPAY_SCRIPT_URL;
      script.async = true;
      script.onload = () => resolve();
      script.onerror = () => {
        razorpayScriptPromise = null;
        reject(new Error("Failed to load Razorpay checkout script"));
      };
      document.body.appendChild(script);
    });
  }
  return razorpayScriptPromise;
}

export function payWithRazorpay(gateway) {
  const orderId = gateway?.razorpay_order_id ?? gateway?.gateway_auth_intent_id;
  const key = gateway?.razorpay_key;
  const amount = gateway?.amount;
  const currency = gateway?.currency ?? "INR";

  if (!orderId || !key || amount == null) {
    return Promise.reject(
      new Error("Incomplete Razorpay gateway payload from prepare response")
    );
  }

  return loadRazorpayScript().then(
    () =>
      new Promise((resolve, reject) => {
        const options = {
          key,
          order_id: orderId,
          amount,
          currency,
          name: "Feed The Tummy",
          handler: (response) => {
            resolve({
              gateway_name: "razorpay",
              gateway_auth_intent_id: response.razorpay_order_id,
              gateway_payment_intent_id: response.razorpay_payment_id,
              razorpay_signature: response.razorpay_signature,
            });
          },
          modal: {
            ondismiss: () => reject(new Error("Razorpay checkout dismissed")),
          },
        };

        const rzp = new window.Razorpay(options);
        rzp.open();
      })
  );
}
